module.exports = __webpack_public_path__ + "img/gs3.4c79f8f1.png";